document.addEventListener('DOMContentLoaded', () => {
  const productMediaSlider = Array.from(document.querySelectorAll(".product-media-slider"));
  console.log(productMediaSlider);
  const flickitySlides = [];
  function changeThumbnail(thumbnailImg, parentElement) {
    const thumbnailList = parentElement.querySelector(".carousel-thumbnail__list");
    const containerWidth = thumbnailList.clientWidth;
    const thumbnailWidth = thumbnailImg.clientWidth;
    const thumbnailLeft = thumbnailImg.offsetLeft;
  
    const scrollTo = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
    thumbnailList.scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    });
  }

  productMediaSlider.forEach((element) => {
    const carousel = element.querySelector(".carousel");
    const productThumbnails = Array.from(element.getElementsByClassName("carousel-thumbnail__list-item"));
    var flickity = new Flickity(carousel, {
      cellAlign: 'left',
      accessibility: false,
      prevNextButtons: true,
      pageDots: false,
      resize: false,
      adaptiveHeight: true,
      selectedAttraction: 1,
      friction: 1,
      draggable: false
    });
    flickitySlides.push(flickity);

    flickity.on('select', function () {
      productThumbnails.forEach(element => {
        element.classList.remove("is-selected");
      });
      productThumbnails[flickity.selectedIndex].classList.add("is-selected");
      changeThumbnail(productThumbnails[flickity.selectedIndex], element);
      flickity.slides.forEach(slide => {
        slide.target = slide.x;
      });
      flickity.settle();
    });

    for (let i = 0; i < productThumbnails.length; i++) {
      productThumbnails[i].addEventListener('click', () => {
        productThumbnails.forEach(element => {
          element.classList.remove("is-selected");
        });
        productThumbnails[i].classList.add("is-selected");
    
        changeThumbnail(productThumbnails[i], element);
    
        flickity.select(i);
      })
    }

    let startX = 0;

    // スワイプ開始時の処理
    carousel.addEventListener('pointerdown', (event) => {
      startX = event.pageX;
    });

    // スワイプ終了時の処理
    carousel.addEventListener('pointerup', (event) => {
        const endX = event.pageX;
        const distance = endX - startX;
        if (distance < -50) {
          // 右にスワイプ
          flickity.next();
        } else if (distance > 50) {
          // 左にスワイプ
          flickity.previous();
        }
    });

      flickity.resize();
      const thumbnailImg = element.querySelector(".carousel-thumbnail__list-item.is-selected");
      changeThumbnail(thumbnailImg, element);
  });

  window.addEventListener('resize', () => {
    productMediaSlider.forEach((element, index) => {
      flickitySlides[index].resize();

      const thumbnailImg = element.querySelector(".carousel-thumbnail__list-item.is-selected");
      changeThumbnail(thumbnailImg, element);
    });
  });
});
